import { Button, Text } from 'components/ui';
import { useTranslation } from 'hooks/useTranslation';
import React from 'react';
import {
    DialogActionTrigger, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogRoot, DialogTitle
} from '../ui/dialog';

interface DeleteConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  loading?: boolean;
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  loading = false
}) => {
  const { t } = useTranslation();

  return (
    <DialogRoot open={isOpen} onOpenChange={(e: { open: boolean }) => e.open ? undefined : onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Text>{message}</Text>
        </DialogBody>
        <DialogFooter>
          <DialogActionTrigger asChild>
            <Button variant="outline" onClick={onClose}>
              {t('app.common.cancel')}
            </Button>
          </DialogActionTrigger>
          <Button
            colorPalette="red"
            onClick={onConfirm}
            loading={loading}
          >
            {t('app.common.delete')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};

export default DeleteConfirmDialog;
